// import { GodotDocsFileIndex } from "../../js/godot-docs/GodotDocsIndex";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { GodotDocsIndexSelector } from "../../js/godot-docs/GodotDocsIndexSelector";
import { Rokojori } from "../../js/Rokojori";
import { GodotSourceLibrary } from "../code-doc/GodotSourceLibrary";

export class GodotIcons
{
  static rokojoriActionLibrary:{ [ key:string ]:string[] } = 
  {
    Action: [ "PlaySound", "PlayParticles","Highlight" ],
    OnEvent: [ "OnCollision", "TriggerOnSensor" ],
    SequenceAction: [ "Flash", "Shake", "ModulateTimeLineSpeed", "CameraEffect" ],
    VirtualCamera3D: [ "ThirdPersonCamera" ],
    Scatterer: [ 
      "GenerateInBox", "GenerateOnSpline", "GenerateInMesh",
      "DiscardNoise","DiscardSpline","DiscardSphere",
      "RandomizeTransform","ProjectOnColliders"
    ],
    UIInputIcon: [ "UIInputInfo" ],
    LocalizedString: [ "LocaleText" ],
    Label3D: [ "LocaleLabel3D" ],
    Spline: [ "Cuboid", "Tube", "GrassPatch", "LeafMesh", "BillboardTree", "Subdivider", "SplineDeformer", "NoiseDeformer" ],
    Node3D: [ "Baker", "MultiBaker", "TextureMerger", "TextureCombiner" ]
  };


  static godot:{ [ key:string ]:string[] } = 
  {
    GeometryInstance3D: [ "CSGBox3D" ]
  }

  static getIcon( lib:{ [ key:string ]:string[] }, className:string )
  {
    for ( let it in lib )
    {
      if ( lib.hasOwnProperty( it ) && it )
      {
        let values = lib[ it ];
        let index = values.indexOf( className );

        if ( index !== -1 )
        {
          return it;
        }
      }
    }

    return null;
  }

  static hasIcon( lib:{ [ key:string ]:string[] }, className:string )
  {
    let icon = GodotIcons.getIcon( lib, className );
    return icon !== null;
  }

  static createNodeIconForClass( className:string )
  {
    let wrapper = document.createElement( "wrapper" );
    let icon = GodotIcons.getNodeIconForClass( className );
    let img = ElementType.image.create();
    ElementAttribute.src.to( img, "::/" + icon );

    wrapper.appendChild( img );

    Rokojori.$.pageHandler.rootPathResolver.process( wrapper, Rokojori.$.pageHandler.currentPage );

    wrapper.removeChild( img );

    return img;
  }

  static getNodeIconForClass( className:string )
  {
    let currentIndex = GodotDocsIndexSelector.currentIndex;

    // console.log( currentIndex );
    
    let classEntry = currentIndex.index.get( className );

    if ( classEntry == null )
    {
      return "_graphics/labs/godot/icons/No-Icon.svg" ;
    }

    return classEntry.icon;

    // if ( GodotSourceLibrary.sourceMap.has( className ) )
    // {
      
    // }

    // if ( GodotIcons.hasIcon( GodotIcons.rokojoriActionLibrary, className ) )
    // {
    //   return GodotIcons.getIcon( GodotIcons.rokojoriActionLibrary, className );
    // } 

    // if ( GodotIcons.hasIcon( GodotIcons.godot, className ) )
    // {
    //   return GodotIcons.getIcon( GodotIcons.godot, className );
    // } 

    // return className;
  }
}